import React from "react";
import ReactDOM from "react-dom/client";
//import App from "./App";
import AppRoutes from "./routes/AppRountes";          // ← AppRoutesを使うように変更
import "./styles/index.css";
import { HashRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';  // 正しいパスにしてください
import { DeviceProvider } from "./components/Tabs/web_parts/DeviceProvider";

// モバイルのキャッシュ対策1（Safariのキャッシュを回避）
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });
}

// モバイルのキャッシュ対策2（Safariのキャッシュを回避）
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <HashRouter>
      <AuthProvider>
        <DeviceProvider>
          <AppRoutes />
        </DeviceProvider>
      </AuthProvider>
    </HashRouter>
  </React.StrictMode>
);

